import { color, hsl } from 'd3-color';

const SATURATION = 4;
const IS_HEX_COLOR_REGEX = /^#(?:[0-9a-fA-F]{3}){1,2}$/;

export const getPaintPropertyName = ({ type: layerType }) => {
  if (layerType === 'symbol') {
    return 'text-color';
  }
  if (layerType === 'line') {
    return 'line-color';
  }
  if (layerType === 'fill') {
    return 'fill-color';
  }
  if (layerType === 'circle') {
    return 'circle-color';
  }
  throw new Error(`Unknown layer type ${layerType}`);
};

const hslToDesaturatedHex = (hslColor) =>
  color(
    `hsl(${hslColor.h}, ${(hslColor.s / SATURATION) * 100}%, ${hslColor.l * 100}%)`,
  ).formatHex();

export const desaturateColor = (fullColor) => {
  const hslColor = hsl(fullColor);
  if (Number.isNaN(hslColor.h) || Number.isNaN(hslColor.s)) return fullColor;
  return hslToDesaturatedHex(hslColor);
};

const getDesaturationExpression = ({ currentColor, saturatedPlanId }) => {
  const desaturated = desaturateColor(currentColor);
  if (!saturatedPlanId) return desaturated;
  const condition = ['!=', ['get', 'plan_id'], saturatedPlanId];
  return ['case', condition, desaturated, currentColor];
};

const valueIsAColor = (val) => {
  return typeof val === 'string' && val.match(IS_HEX_COLOR_REGEX);
};

export const getNewPaintProperty = ({ currentColorExpression, saturatedPlanId }) => {
  if (typeof currentColorExpression === 'string') {
    return getDesaturationExpression({ currentColor: currentColorExpression, saturatedPlanId });
  }
  return currentColorExpression.map((value) =>
    valueIsAColor(value)
      ? getDesaturationExpression({ currentColor: value, saturatedPlanId })
      : value,
  );
};
